import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { LS2PAC_Utils } from "../../utils/Utils";
import { TitlesSearchClientManager } from "./TitlesSearchClientManager";

export class BritannicaSearchClientManager extends TitlesSearchClientManager {
  constructor(options) {
    super(options);
    this.originalPageSize = options.pageSize;
    this.addExtraListeners();
  }
  getSearchParams() {
    return {
      searchTerm: LS2PAC_Utils.getQualifiedSearchTerm(
        this.searchTermInfo.value,
        this.searchTermInfo.type
      ),
      startIndex: this.currentPage * this.pageSize + 1,
      hitsPerPage: this.pageSize,
      facetFilters: [],
      branchFilters: [],
      sortCriteria: this.sortingData.sortKey,
      targetAudience: "",
      addToHistory: false,
      dbCodes: [],
    };
  }
  addExtraListeners() {
    var _this = this;

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onHome,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        _this.extraDataToPassBack.isAdvanced = true;
        _this.searchTermInfo = {
          value: JSON.stringify(event.searchString),
          type: LS2PAC_CONSTANTS.searchFields.advanced,
        };
        _this.resetPageCache(true);
        _this.getSearchCount();
      }
    );
  }
}
